@switch (type) {
  @case (CHIP_TYPES.SELECTABLE) {
    <mat-chip class="chip [&_.mat-mdc-chip-action-label]:!font-medium" [ngClass]="{'selected': isSelected}" (click)="toggleSelection()" [disabled]="isDisabled">
      <div class="py-2 chip-content">
        {{ name }}
        <div class="icon-md">
          <app-icon [ngClass]=" isSelected ? 'text-success' : 'text-danger'">{{isSelected ? 'done' : 'close'}}</app-icon>
        </div>
      </div>
    </mat-chip>
  }

  @case (CHIP_TYPES.DEFAULT) {
    <p-chip class="default-chip"
            [styleClass]="noWrap ? 'inline-flex min-w-0 max-w-full items-center overflow-hidden whitespace-nowrap' : undefined"
            [removable]="isClose"
            (onRemove)="onChangeClose.emit()">
      <span [class]="noWrap ? 'flex min-w-0 flex-1 items-center gap-1.5 overflow-hidden' : 'contents'">
        <ng-content></ng-content>
      </span>
    </p-chip>
  }
}
